import { render } from "./CentreCheque.vue?vue&type=template&id=0451a6ea&ts=true"
import script from "./CentreCheque.vue?vue&type=script&lang=ts"
export * from "./CentreCheque.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__